import { render, staticRenderFns } from "./AddResponsibilityBook.vue?vue&type=template&id=12cc2a8c&scoped=true"
import script from "./AddResponsibilityBook.vue?vue&type=script&lang=js"
export * from "./AddResponsibilityBook.vue?vue&type=script&lang=js"
import style0 from "./AddResponsibilityBook.vue?vue&type=style&index=0&id=12cc2a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cc2a8c",
  null
  
)

export default component.exports